var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"contenteditable":"true"},on:{"keydown":_vm.onKeyDown,"input":function($event){_vm.changed = true},"focus":_vm.onFocus,"blur":_vm.onBlur,"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }